
import { mapGetters, mapActions } from 'vuex'
import { CHATS } from '../../store/modulesNames'
import { IS_SHOW_CHAT_HISTORY } from '../../store/gettersTypes'
import { ACT_SET_CHAT_SHOW_HISTORY } from '../../store/actionsTypes'

import CustomSwitchItem from '../custom/CustomSwitchItem.vue'
import { CHAT_TYPES } from '../../constants'

export default {
    name: 'ShowHistorySwitch',
    extends: CustomSwitchItem,
    props: {
        cid: {
            type: Number,
            required: true,
        },
        cidType: {
            type: String,
            default: CHAT_TYPES.USER
        }
    },
    computed: {
        title() {
            return this.$t('chat.group-chat.show-history')
        },
        switchValue() { return this[IS_SHOW_CHAT_HISTORY]({ cid: this.cid, cidType: this.cidType }) },
        ...mapGetters(CHATS, [IS_SHOW_CHAT_HISTORY])
    },
    methods: {
        turnOn() {
            this[ACT_SET_CHAT_SHOW_HISTORY]({ cid: this.cid, cidType: this.cidType, showHistory: true })
        },
        turnOff() {
            this[ACT_SET_CHAT_SHOW_HISTORY]({ cid: this.cid, cidType: this.cidType, showHistory: false })
        },
        onClick() {
            if (this.switchValue) this.turnOff()
            else this.turnOn()
        },
        ...mapActions(CHATS, [ACT_SET_CHAT_SHOW_HISTORY])
    },
}
